/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { accessAPI, Titulo, Formulario, Boton, Sidebar } from "../../../shared";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";

export default function CardLogo({ clienteId }) {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [loaderFormulario, setLoaderFormulario] = useState(false);
  const [loader, setLoader] = useState(true);
  const [logo, setLogo] = useState(null);

  const toast = useRef(null);

  useEffect(() => {
    accessAPI(
      "GET",
      `admin/cliente/${clienteId}/logo`,
      null,
      (respuesta) => {
        setLogo(respuesta);
        setLoader(false);
      },
      () => {
        setLoader(false);
      }
    );
  }, [clienteId]);

  function subirLogo(campos, archivo) {
    setLoaderFormulario(true);
    accessAPI(
      "PUT",
      `admin/cliente/${clienteId}/logo`,
      null,
      (respuesta) => {
        setLoaderFormulario(false);
        setSidebarVisible(false);
        setLogo(respuesta);
      },
      (respuesta) => {
        setLoaderFormulario(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0].msg,
          sticky: true
        });
      },
      archivo
    );
  }

  const logoFormConfig = {
    secciones: [
      {
        nombre: "Actualizar logo",
        descripcion: "Subir o editar logo para la empresa",
        campos: [
          {
            nombre: "logo",
            tipoitemformularioid: 10,
            requerido: true,
            etiqueta: "Logo"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Actualizar logo",
        callback: subirLogo,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Formulario config={logoFormConfig} loader={loaderFormulario} />
      </Sidebar>

      <Card>
        <Titulo
          botones={
            <Boton texto negro chico callback={() => setSidebarVisible(true)}>
              <i className="pi pi-pencil" />
            </Boton>
          }
        >
          Logo
        </Titulo>

        {loader && (
          <div
            css={{ display: "flex", justifyContent: "center", padding: "2em" }}
          >
            <Skeleton width="150px" height="150px" />
          </div>
        )}

        {!loader && logo && (
          <div
            css={{ display: "flex", justifyContent: "center", padding: "1em" }}
          >
            <img
              src={URL.createObjectURL(logo)}
              alt="Logo"
              css={{
                maxWidth: "200px",
                maxHeight: "200px",
                objectFit: "contain"
              }}
            />
          </div>
        )}

        {!loader && !logo && (
          <div
            css={{
              display: "flex",
              justifyContent: "center",
              padding: "2em",
              color: "var(--text-color-secondary)"
            }}
          >
            Sin logo
          </div>
        )}
      </Card>
    </>
  );
}
